import { useEffect, useState } from 'react';

export interface ToastProps {
  id?: string;
  message: string;
  variant?: 'success' | 'error' | 'info';
  duration?: number;
  onClose?: () => void;
}

export function Toast({
  message,
  variant = 'success',
  duration = 4000,
  onClose,
}: ToastProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        onClose?.();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  if (!isVisible) return null;

  const variantStyles = {
    success: 'bg-feedback-success text-white border-feedback-success/50',
    error: 'bg-feedback-danger text-white border-feedback-danger/50',
    info: 'bg-navy-light text-white border-brand-orange/50',
  };

  return (
    <div
      role={variant === 'error' ? 'alert' : 'status'}
      aria-live="polite"
      className={`fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-xl border px-4 py-3 shadow-2xl transition-all duration-300 ${variantStyles[variant]}`}
    >
      <span className="text-xs font-semibold sm:text-sm">{message}</span>
      <button
        type="button"
        onClick={() => {
          setIsVisible(false);
          onClose?.();
        }}
        aria-label="Fechar notificação"
        className="ml-2 text-white/80 hover:text-white"
      >
        <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
}
